export default __webpack_public_path__ + "ef74e06eeab84032150e14e7003a53ed.svg";